export enum EmployeeNameFormatEnums {
  LNAME_FNAME,
  LNAME_FNAME_EMPCODE,
  LNAME_FNAME_PAYROLLCODE,
  EMPCODE,
  PAYROLLCODE,
  EMPCODE_LNAME_FNAME,
  PAYROLLCODE_LNAME_FNAME,
  FNAME_LNAME,
}
